import {Col, Row} from 'antd';
import {useFormikContext} from 'formik';
import {Input} from 'formik-antd';
import {FC} from 'react';
import {useIntl} from 'react-intl';
import FormItem from '../../../../../shared/components/form-item';
import {
  getLocaleValue,
  handleChangeLocales,
} from 'src/shared/functions/change-locales';

type langComponentProps = {
  code?: string;
  index?: number;
};

const LangComponent: FC<langComponentProps> = ({code, index}) => {
  const {setFieldValue, values} = useFormikContext<any>();
  const {messages} = useIntl();

  return (
    <Row justify='center' gutter={[20, 20]}>
      <Col span={24}>
        <FormItem
          name='name'
          label={messages['specificationAttributes.name'].toString()}
          fieldCommponent={
            <Input
              name='name'
              value={getLocaleValue(values?.locales, code, 'name')}
              onChange={(value) =>
                handleChangeLocales(
                  values?.locales,
                  setFieldValue,
                  `locales`,
                  code,
                  'name',
                  value.target.value,
                )
              }
            />
          }
        />
      </Col>
    </Row>
  );
};

export default LangComponent;
